export const featuredPortfolio = [
    {
      id: 1,
      title: "WebGPT-3 Website",
      img:
      "assets/ProjectCollage/webApp/gpt3collage.jpeg",
    },
    {
      id: 2,
      title: "Beauty Product Website",
      img:
      "assets/ProjectCollage/webApp/beautyproductcollage.jpeg",  
    },
    {
      id: 3,
      title: "HDPlus App",
      img:
      "assets/ProjectCollage/mobileApp/hdpluscollage.jpeg",  
    },
    {
      id: 4,
      title: "E-Learn",
      img:
        "assets/ProjectCollage/webApp/stuccollage.png",
    },
    {
      id: 5,
      title: "EZSwiftShops",
      img:
      "assets/ProjectCollage/mobileApp/ezswiftshopcollage.jpeg"    
    },
    {
      id: 6,
      title: "EzSwiftShops RestAPI",
      img:
      "assets/ProjectCollage/RestAPI/ezswiftshopRestapi.png"    
    },
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "WebGPT-3 Website",
      img:
      "assets/ProjectCollage/webApp/gpt3collage.jpeg",
    },
    {
      id: 2,
      title: "Beauty Product Website",
      img:
      "assets/ProjectCollage/webApp/beautyproductcollage.jpeg",      },
    {
      id: 3,
      title: "HDPlus App DashBoard",
      img:
      "assets/ProjectCollage/webApp/hdplusgraphcollage.png",      },
    {
      id: 4,
      title: "E-Learn",
      img:
      "assets/ProjectCollage/webApp/stuccollage.png",      },

  ];
  
  export const mobilePortfolio = [
    {
      id: 1,
      title: "HDPlus App",
      img:
      "assets/ProjectCollage/mobileApp/hdpluscollage.jpeg"    
    },
    {
      id: 2,
      title: "EZ-Transfer",
      img:
      "assets/ProjectCollage/mobileApp/eztransfercollage.jpeg"    
    },
    {
      id: 3,
      title: "EZSwiftShops",
      img:
      "assets/ProjectCollage/mobileApp/ezswiftshopcollage.jpeg"    
    },
    {
      id: 4,
      title: "CryptoApp",
      img:
      "assets/ProjectCollage/mobileApp/cryptoappcollage.jpeg"    
       },
    {
      id: 5,
      title: "Mobile Hero Design",
      img:
        "https://cdn.dribbble.com/users/26642/screenshots/15462545/media/1a202ef5c8338b6f78634e6edc1ba350.png?compress=1&resize=1200x900",
    },
    {
      id: 6,
      title: "Mobile Banking App",
      img:
        "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
    },
  ];
  
  export const designPortfolio = [
    {
      id: 1,
      title: "EZSwiftShops RestAPI",
      img:
      "assets/ProjectCollage/RestAPI/ezswiftshopRestapi.png"    
      },
    {
      id: 2,
      title: "HdPlus RestAPI",
      img:
      "assets/ProjectCollage/RestAPI/hdplusapicollage.png"    
      },
    
  ];
  
  export const contentPortfolio = [
    {
      id: 1,
      title: "Python",
      img:
      "assets/pythonwallpaper.png",
    },
    {
      id: 2,
      title: "JavaScript",
      img:
      "assets/jswallpaper.png",
    },
    {
      id: 7,
      title: "GOLang",
      img:
      "assets/golangwallpaper.png",
        },
    {
      id: 3,
      title: "React-Native",
      img:
      "assets/reactnative.png",
        },
    {
      id: 4,
      title: "Django",
      img:
      "assets/djwallpaper.png", 
       },
    {
      id: 5,
      title: "DjangoRestFramework",
      img:
      "assets/djrestapiwallpaper.png"
    },
    // {
    //   id: 6,
    //   title: "ReactJs",
    //   img:
    //   "assets/reactjswallpaper.png"
    // },
  ];
  